import React from 'react'
import { isEmpty } from 'lodash'
import styled from 'styled-components'
import { EduButton, Label, notification } from '@edulastic/common'
import { Title } from '../common'
import { StyledDropDownContainer } from '../../../Reports/common/styled'
import { ControlDropDown } from '../../../Reports/common/components/widgets/controlDropDown'

const StepLabel = styled(Label)`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: -0.5rem;
  margin-top: 1rem;
`

const StandardSetMasteryBandStep = ({
  curriculumDropdownOptions,
  selectedCurriculumId,
  setSelectedCurriculumId,
  standardsProficiencyProfiles,
  selectedProficiencyProfile,
  setSelectedProfileId,
  isLoadingGroups,
  setIsLoadingGroups,
  onContinueWithProfileAndCurriculum,
  onStepComplete,
}) => (
  <div
    style={{
      margin: 'auto',
      maxWidth: 'fit-content',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      fontWeight: 400,
    }}
  >
    <Title>Confirm the Standard Set and Mastery Band</Title>
    {!isEmpty(curriculumDropdownOptions) && (
      <>
        <StepLabel>Standard set</StepLabel>
        <StyledDropDownContainer
          data-cy="standardSet"
          xs={24}
          sm={24}
          md={7}
          lg={7}
          xl={7}
          margin="0 10px 0 0"
          width="40rem"
        >
          <ControlDropDown
            prefix="Standard Set"
            by={selectedCurriculumId || ''}
            selectCB={(selected) => setSelectedCurriculumId(selected.key)}
            data={curriculumDropdownOptions}
            showPrefixOnSelected={false}
            overlayStyle={{ zIndex: 9999 }}
          />
        </StyledDropDownContainer>
      </>
    )}
    <StepLabel>Mastery band</StepLabel>
    <StyledDropDownContainer
      data-cy="masteryBand"
      xs={24}
      sm={24}
      md={7}
      lg={7}
      xl={7}
      margin="0 10px 0 0"
      width="40rem"
    >
      <ControlDropDown
        prefix="Mastery Band"
        by={selectedProficiencyProfile._id || ''}
        selectCB={(selected) => setSelectedProfileId(selected.key)}
        data={standardsProficiencyProfiles.map((profile) => ({
          key: profile._id,
          title: profile.name,
        }))}
        showPrefixOnSelected={false}
        overlayStyle={{ zIndex: 9999 }}
      />
    </StyledDropDownContainer>
    <div>
      <EduButton
        loading={isLoadingGroups}
        onClick={async () => {
          if (onContinueWithProfileAndCurriculum) {
            setIsLoadingGroups(true)
            try {
              await onContinueWithProfileAndCurriculum()
              onStepComplete()
            } catch (e) {
              notification({
                msg: 'Failed to load intervention data. Please try again.',
              })
            } finally {
              setIsLoadingGroups(false)
            }
          } else {
            onStepComplete()
          }
        }}
        style={{ marginTop: '1rem' }}
      >
        Continue
      </EduButton>
    </div>
  </div>
)

export default StandardSetMasteryBandStep
